import axios from 'axios';

const api = axios.create({ baseURL: '/api' });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('kspro_token');
  if (token) config.headers['x-auth-token'] = token;
  return config;
});

// An expired/invalid token used to leave the app silently broken until a manual relog —
// send the user back to the login screen instead
api.interceptors.response.use(null, (err) => {
  if (err.response?.status === 401 && localStorage.getItem('kspro_token')) {
    window.dispatchEvent(new Event('kspro:unauthorized'));
  }
  return Promise.reject(err);
});

export default api;
